import { useModal } from '@/components/modal/useModal';
import { SidebarLink } from '@/components/sidebar/SidebarLink';
import { SidebarMainSection } from '@/components/sidebar/SidebarMainSection';
import SiPlusCircle from '@/icons/SiPlusCircle';
import SiUpload from '@/icons/SiUpload';
import { getMyCatalogueLink } from '@/lib/getMyLinks';
import { CreateCategoryModal } from '@/pages/product/category/CreateCategoryModal';
import { EditCategoryModal } from '@/pages/product/category/EditCategoryModal';
import { sidebarItemClassName } from '@/pages/product/category/helper';
import { CreateManufacturerModal } from '@/pages/product/manufacturer/CreateManufacturerModal';
import { productExplorerStrings } from '@/pages/product/strings';
import { RoleType, useUser } from '@/services/authentication/hooks/user';
import clsx from 'clsx';
import { FC } from 'react';
import { CategoryLinks } from './CategoryLinks';

export const ConfiguratorLinks: FC = () => {
  const { role } = useUser();
  const catalogueLink = getMyCatalogueLink(role);

  const createCategoryModalProps = useModal();
  const editCategoryModalProps = useModal<{ categoryId: string }>();
  const createManufacturerModalProps = useModal();

  const catalogueId = role.type === RoleType.Admin ? 'configurator' : 'mspCatalogue';
  const sectionUrlIdentifier = role.type === RoleType.Admin ? 'configuratorCatalogue' : 'mspCatalogue';

  return (
    <SidebarMainSection
      sectionUrlIdentifier={sectionUrlIdentifier}
      title={'DaaS Portal Catalogue '}
      to={catalogueLink}
      collapsible
    >
      <CategoryLinks
        baseUrl={catalogueLink}
        baseId={catalogueId}
        onEdit={role.type === RoleType.Admin ? (id => editCategoryModalProps.open({ categoryId: id })) : undefined}
      />
      {role.type === RoleType.Admin && (
        <>
          <SidebarLink to="/configuratorCatalogue/product/bulk">
            <div className="flex items-center gap-1">
              <SiUpload className="text-2xl" />
              <span>{productExplorerStrings.bulkUploadProducts}</span>
            </div>
          </SidebarLink>
          <SidebarLink to="/configuratorCatalogue/product/create">
            <div className="flex items-center gap-1">
              <SiPlusCircle className="text-2xl" />
              <span>{productExplorerStrings.addNewProduct}</span>
            </div>
          </SidebarLink>
          <button className={clsx('font-medium', sidebarItemClassName)} onClick={() => createCategoryModalProps.open()}>
            <div className="flex items-center gap-1">
              <SiPlusCircle className="text-2xl" />
              <span>{productExplorerStrings.createCategory}</span>
            </div>
          </button>
          <button
            className={clsx('font-medium', sidebarItemClassName)}
            onClick={() => createManufacturerModalProps.open()}
          >
            <div className="flex items-center gap-1">
              <SiPlusCircle className="text-2xl" />
              <span>{productExplorerStrings.createManufacturer}</span>
            </div>
          </button>
          <CreateCategoryModal {...createCategoryModalProps} />
          <EditCategoryModal {...editCategoryModalProps} />
          <CreateManufacturerModal {...createManufacturerModalProps} />
        </>
      )}
    </SidebarMainSection>
  );
};
